import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./authInput.css";

function AuthInput({
  label,
  type,
  placeholder,
  autocomplete,
  value,
  onChange,
  onCopy,
  onPaste,
}) {
  const isPassword = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="input-wrapper">
      <div className="input">
        <label>{label}</label>
        <div className={isPassword ? "auth-input-field" : ""}>
          <input
            type={isPassword ? (showPassword ? "text" : "password") : type}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className="form-control"
            autoComplete={autocomplete}
            required
            onCopy={onCopy}
            onPaste={onPaste}
          />

          {isPassword && (
            <button
              type="button"
              className="auth-eye-btn"
              onMouseDown={(e) => e.preventDefault()} // prevents input blur
              onClick={() => setShowPassword((p) => !p)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthInput;